import {Injectable} from '@angular/core';
import {ActivatedRouteSnapshot, Params, Router, RouterStateSnapshot} from '@angular/router';

import {AuthService} from '@app/_service/auth.service';
import {Const} from "@app/_helper/const";
import {Logger} from "@app/logger";

@Injectable({
  providedIn: 'root'
})
export class AuthGuard {

  private readonly log = new Logger();

  constructor(
    private readonly router: Router,
    private readonly authService: AuthService
  ) {
  }

  public canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean {
    const returnUrl = (state.url == `/${Const.URI_HOME}`) ? '' : state.url;
    const queryParams: Params = {};
    if (returnUrl) {
      queryParams[Const.PARAM_RETURNURL] = returnUrl;
    }

    if (this.authService.isLoggedIn) {
      const account = this.authService.account;
      if (this.authService.isNeed2fa) {
        this.log.warn('AuthGuard activated!');
        this.router.navigate([`/${Const.URI_AUTH}/${Const.URI_AUTH_LOGIN_2FA}`], {queryParams: queryParams});
        return false;
      }
      this.log.trace('AuthGuard.canActivate OK');
      this.log.trace('account:', account);
      return true;
    }

    this.log.warn('AuthGuard activated!');
    this.router.navigate([`/${Const.URI_AUTH}/${Const.URI_AUTH_LOGIN}`], {queryParams: queryParams});
    return false;
  }
}
